import { Container, Select } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const SortingOptionsContainer = styled.div`
    display: flex;
    justify-content: end;
    margin: ${getPurpurSpacing('300')} 0;

    ${purpurMedia('md')`
        margin: ${getPurpurSpacing('400')} 0;
    `};
`;

export const ArticleListContainer = styled(Container)<{ $withTopPadding?: boolean }>`
    padding-bottom: ${getPurpurSpacing('400')};
    padding-top: ${({ $withTopPadding }) => ($withTopPadding ? getPurpurSpacing('300') : 0)};

    ${({ $withTopPadding }) =>
        purpurMedia('md')`
            padding-top: ${$withTopPadding ? getPurpurSpacing('400') : 0};
            padding-bottom: ${getPurpurSpacing('600')};
        `}
`;

export const StyledSelect = styled(Select)`
    width: 100%;
    ${purpurMedia('md')`
        width: auto;
    `};
`;
